<div class="page_heading">
  <div class="container">
      <h2>{{title}}</h2>
  </div>
</div>

<div class="certificate-download text-center my-4">
  <a routerLink="/e-certificate" class="btn-certificate rs-btn rs-btn--primary" rsRipple>
    <span class="btn-certificate__emoji" aria-hidden="true">🎓</span>
    <span>Click here to get your <strong>e-Certificate</strong></span>
    <span class="rs-btn__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </span>
  </a>
</div>

<app-banner [BannerData]="bannerArray"></app-banner>


<!-- -------------------------our-business Section Start----------------- -->
<section class="our-business rs-section itn" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--br"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-dots rs-dots--pink rs-dots--c"></span>
    <span class="rs-spark" style="--sx: 9%; --sy: 36%; --sd: 0.6s"></span>
    <span class="rs-spark" style="--sx: 91%; --sy: 18%; --sd: 2.2s"></span>
  </div>

  <div class="rs-shell">
    <header class="row our-business-heading mt-0 itn__head" rsReveal="up">
      <div class="col-sm-12">
        <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">Learn with us</span>
        <h2>Internship<span class="rs-title-grad">/Training</span></h2>
        <h3>Welcome to Resiliencesoft, a leading IT company that specialises in developing innovative and cutting-edge software solutions. We are thrilled to offer an exciting training and paid internship opportunity for those looking to gain practical experience in the field of IT.</h3>
      </div>
    </header>

    <div class="itn__steps">
<ng-container *ngFor="let data of ourProducts | keyvalue let i=index;">
        <div *ngIf="i % 2 == 0" class="row content-one itn__step" [class.mt-0]="i>1" rsReveal="up">
          <div class="col-sm-6 center-line itn__media">
            <div class="itn__frame rs-frame">
              <img loading="lazy" src="{{data.value.img}}" alt="product" width="400">
            </div>
            <div class="s-no">
              <span>{{i+1}}</span>
            </div>
          </div>
          <div class="col-sm-6 googleRanking itn__copy">
            <div class="float">
              <h3>{{data.value.heading}} Internship / {{data.value.heading}} Training</h3>
              <span class="itn__rule" aria-hidden="true"></span>
              <p>{{data?.value?.features}}</p>
            </div>
          </div>
        </div>
        <div *ngIf="i % 2 != 0" class="row content-one mt-0 itn__step itn__step--flip" rsReveal="up">
          <div class="col-sm-6 localseoservice itn__copy">
            <div class="float-l">
              <h3>{{data.value.heading}} Internship / {{data.value.heading}} Training</h3>
              <span class="itn__rule" aria-hidden="true"></span>
              <p class="one-p">{{data?.value?.features}}</p>
            </div>
          </div>
          <div class="col-sm-6 center-line-l itn__media">
            <div class="itn__frame rs-frame">
              <img loading="lazy" src="{{data.value.img}}" alt="product" width="400">
            </div>
            <div class="s-no-l">
              <span>{{i+1}}</span>
            </div>
          </div>
        </div>
</ng-container>
    </div>
  </div>
  </section>

<!-- -------------------------our-business Section end----------------- -->

<!-- -------------------------our-business-mobile Section start----------------- -->
<section class="our-business-mobile rs-section itnm">
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--br"></span>
  </div>

  <div class="rs-shell">
    <header class="row our-business-heading mt-0 itn__head">
      <div class="col-sm-12">
        <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">Learn with us</span>
        <h2>Internship<span class="rs-title-grad">/Training</span></h2>
        <h3>Welcome to Resiliencesoft, a leading IT company that specialises in developing innovative and cutting-edge software solutions. We are thrilled to offer an exciting training and paid internship opportunity for those looking to gain practical experience in the field of IT.</h3>
      </div>
    </header>

    <div class="itnm__list">
  <ng-container *ngFor="let data of ourProducts | keyvalue let i=index;">
  <article *ngIf="i % 2 == 0" class="row content-one mt-5 itnm__card" rsReveal="up">
    <div class="col-sm-6 center-line itnm__media">
      <div class="itn__frame rs-frame">
        <img loading="lazy" src="{{data.value.img}}" alt="product">
      </div>
      <div class="s-no">
        <span>{{i+1}}</span>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="container float">
        <h3>{{data.value.heading}}</h3>
        <span class="itn__rule" aria-hidden="true"></span>
        <p>{{data?.value?.features}}</p>
      </div>
    </div>
  </article>
  <article *ngIf="i % 2 != 0" class="row content-one mt-0 itnm__card" rsReveal="up">
    <div class="col-sm-6 center-line-l itnm__media">
      <div class="itn__frame rs-frame">
        <img loading="lazy" src="{{data.value.img}}" alt="product">
      </div>
      <div class="s-no-l">
        <span>{{i+1}}</span>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="container float">
        <h3>{{data.value.heading}}</h3>
        <span class="itn__rule" aria-hidden="true"></span>
        <p class="one-p">{{data?.value?.features}}</p>
      </div>
    </div>
  </article>
</ng-container>
    </div>
  </div>
</section>
<!-- -------------------------our-business-mobile Section end----------------- -->

<section class="rs-section itn__offer" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--indigo rs-blob--tr"></span>
    <span class="rs-blob rs-blob--pink rs-blob--bl"></span>
    <span class="rs-dots rs-dots--b"></span>
  </div>

  <hr class="mt-0 rs-hairline">

  <div class="rs-shell">
    <header class="title-wrapper rs-head--center" rsReveal="up">
      <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">Programmes</span>
      <h2 class="m-5">We Offer Complete <span class="rs-title-grad">Internship/Training</span></h2>
    </header>

    <div class="container tech-wrap mt-5">
      <div class="row itn__cards" rsReveal="up" rsRevealStagger=".card" rsRevealGap="0.07">
          <div class="itn__cell" *ngFor="let offer of completeOffer">
              <div class="card rs-card rs-card--wash">
                <div class="itn__card-media rs-frame">
                  <img loading="lazy" class="card-img-top w-100" [src]="offer.img" [alt]="offer.heading">
                </div>
                  <div class="card-body">
                      <h5 class="card-title">{{offer.heading}}</h5>
                      <p class="card-text text-justify">{{ selectedOfferId === offer.id && readMore ? offer.features : offer.features.substr(0,125).concat('...') }}</p>
                      <a *ngIf="selectedOfferId !== offer.id" class="btn button-text rs-link" (click)="expandOffer(offer.id)" tabindex="0" role="button">
                        Read More
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a>
                      <a *ngIf="selectedOfferId === offer.id" class="btn button-text rs-link" (click)="collapseOffer()" tabindex="0" role="button">
                        Read Less
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <path d="M19 12H6M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.4"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a>
                  </div>
              </div>
          </div>
          <!-- <div class="col-md-4">
              <div class="card">
                  <div class="card-body">
                      <h5 class="card-title"><img class="w-100" src="../../assets/img/website.webp"></h5>
                      <p class="card-text">Some quick example text to build on the card title and make up the</p>
                      <a href="#" class="btn btn-primary">Read More</a>
                  </div>
              </div>
          </div>
          <div class="col-md-4">
              <div class="card">
                  <div class="card-body">
                      <h5 class="card-title"><img class="w-100" src="../../assets/img/website.webp"></h5>
                      <p class="card-text">Some quick example text to build on the card title and make up the</p>
                      <a href="#" class="btn btn-primary">Read More</a>
                  </div>
              </div>
          </div> -->
      </div>
    </div>
  </div>
</section>
